import restify from './restify';

const service = {
  ...restify('users'),
};

export default service;
